import { compileArticle } from "./compile-article" with { type: "macro" };
import type { Article } from "./manifest";

// The concrete Article manifest: the single source of truth for the Compendium's content set. Each entry is
// one Markdown file plus this one line; `compileArticle(slug)` is a build-time macro, so its call is
// replaced by the compiled HTML string and remark stays out of the client bundle. The pure manifest
// functions (resolveArticle, articleNav) live in manifest.ts and are tested against fixtures; this is
// the real data they operate on, mirroring how catalogEntries backs the catalog seam.
export const ARTICLES: Article[] = [
  {
    slug: "principles",
    title: "General Principles",
    navOrder: 1,
    description: "The logic of the layout.",
    html: compileArticle("principles"),
  },
  {
    slug: "getting-started",
    title: "Getting Started",
    navOrder: 2,
    description: "Download, install, and learn the layout.",
    html: compileArticle("getting-started"),
  },
  {
    slug: "versions",
    title: "Version History",
    navOrder: 3,
    description: "Key changes with each version.",
    html: compileArticle("versions"),
  },
  {
    slug: "faq",
    title: "FAQ",
    navOrder: 4,
    description: "Common questions.",
    html: compileArticle("faq"),
  },
];
